export const SPECIES = { dog: "Hund", cat: "Kat" };
export const PRICE_TYPE = { FIXED: "Fast pris", FROM: "Fra-pris", RANGE: "Prisinterval", ESTIMATE: "Estimat" };
export const CANDIDATE_PRICE_TYPE = { ...PRICE_TYPE, UNKNOWN: "Ukendt" };
export const FREQUENCY = { MANUAL: "Kun manuelt", WEEKLY: "Ugentligt", BIWEEKLY: "Hver 14. dag", MONTHLY: "Månedligt" };
export const REVIEW_STATUS = {
  PENDING_REVIEW: "Afventer godkendelse", CLINIC_CONFIRMATION_REQUESTED: "Afventer klinik", APPROVED: "Godkendt", REJECTED: "Afvist",
  CLINIC_CONFIRMED: "Bekræftet af klinik", CLINIC_REJECTED: "Afvist af klinik", NO_CHANGE: "Uændret",
  CLINIC_CONFIRMED_PENDING_ADMIN: "Bekræftet af klinik – afventer VetPris",
};
export const OPEN_REVIEW = ["PENDING_REVIEW", "CLINIC_CONFIRMATION_REQUESTED", "CLINIC_CONFIRMED_PENDING_ADMIN"];
export const JOB_STATUS = {
  QUEUED: "I kø", RUNNING: "Kører", RETRY_WAIT: "Venter på nyt forsøg", CANCEL_REQUESTED: "Annullerer", SUCCEEDED: "Gennemført",
  FAILED: "Fejlet", CANCELLED: "Annulleret", BLOCKED: "Blokeret",
};
export const VAT = { INCLUDED: "Inkl. moms", EXCLUDED: "Ekskl. moms" };
export const ISSUES = {
  NEGATIVE_PRICE: "Negativ pris", UNSUPPORTED_OR_MISSING_CURRENCY: "Ukendt/ikke-understøttet valuta", CLINIC_MISSING: "Klinik mangler",
  INVALID_SERVICE_MAPPING: "Ingen gyldig behandling", MISSING_OR_INVALID_SPECIES: "Dyreart mangler", INVALID_VARIANT: "Ugyldig variant",
  MISSING_SOURCE: "Kilde mangler", UNKNOWN_PRICE_TYPE: "Ukendt pristype", SINGLE_AMOUNT_EXPECTED: "Kun ét beløb tilladt", INVALID_RANGE: "Ugyldigt interval",
  LOW_CONFIDENCE: "Lav sikkerhed", VAT_UNKNOWN: "Moms ukendt", SUSPICIOUS_CONTENT: "Mistænkeligt indhold (mulig prompt-injection)",
  UNUSUAL_CHANGE: "Usædvanlig prisændring", AI_FALLBACK: "AI utilgængelig – regelbaseret",
  QUALIFIED_PACKAGE: "Pakke/tilvalg – tjek sammenlignelighed", ADDITIONAL_FEES: "Tillægsgebyrer fundet", ZERO_PRICE: "Pris 0 kr. (gratis)",
  INVALID_AMOUNT: "Ugyldigt beløb",
};
export const BLOCK_REASON = {
  GLOBAL_STOP: "Nødstop aktivt", DOMAIN_PAUSED: "Domænet er sat på pause", PERMISSION_NOT_APPROVED: "Tilladelse ikke godkendt",
  PERMISSION_EXPIRED: "Tilladelsen er udløbet", NO_PERMISSION_BASIS: "Intet adgangsgrundlag", RIGHTS_RESERVED_OR_UNRESOLVED: "Rettighedsforbehold uafklaret",
  ACCESS_RESTRICTED: "Adgang begrænset", COLLECTION_DISABLED: "Indsamling deaktiveret",
};
export const JOB_ERROR = {
  ...Object.fromEntries(Object.entries(BLOCK_REASON).map(([k, v]) => [`BLOCKED_${k}`, `Blokeret: ${v.toLowerCase()}`])),
  BLOCKED_IP: "Blokeret: intern/privat IP-adresse", EXTERNAL_DOMAIN: "Uden for godkendt domæne", UNSUPPORTED_SCHEME: "Protokol ikke tilladt",
  PORT_NOT_ALLOWED: "Port ikke tilladt", USERINFO_NOT_ALLOWED: "Brugerinfo i URL ikke tilladt", DNS_FAILED: "DNS-opslag fejlede",
  TIMEOUT: "Tidsgrænse overskredet", NETWORK_ERROR: "Netværksfejl", ACCESS_RESTRICTED: "Adgang nægtet (401/403) – ingen omgåelse forsøgt",
  NOT_FOUND: "Side ikke fundet", HTTP_404: "Side ikke fundet (404)", HTTP_410: "Side fjernet (410)", HTTP_429: "For mange forespørgsler (429)",
  HTTP_500: "Serverfejl (500)", HTTP_502: "Serverfejl (502)", HTTP_503: "Tjeneste utilgængelig (503)", TOO_MANY_REDIRECTS: "For mange omdirigeringer",
  DOCUMENT_TOO_LARGE: "Dokumentet er for stort", UNSAFE_CONTENT_TYPE: "Filtype ikke tilladt", INVALID_PDF: "Ugyldig PDF", PATH_TRAVERSAL: "Ugyldig sti",
  ROBOTS_DISALLOWED: "Afvist af robots.txt (teknisk signal)", CANCELLED: "Annulleret", CANCELLED_BY_ADMIN: "Annulleret af administrator",
  SOURCE_DELETED: "Kilden er slettet", SOURCE_MISSING: "Kilden findes ikke", CLINIC_OPT_OUT: "Klinikken har fravalgt indsamling",
  PERMISSION_REVOKED: "Tilladelse tilbagekaldt", STALE_JOB_RECOVERED: "Genoptaget efter genstart", GLOBAL_STOP: "Nødstop",
  DOMAIN_PAUSED: "Domæne sat på pause", REDIRECT_TO_ALREADY_SEEN: "Omdirigeret til allerede besøgt side",
};
export const jobError = (e) => (e ? JOB_ERROR[e] || (e.startsWith("ROBOTS_UNAVAILABLE_") ? "robots.txt utilgængelig" : e.startsWith("ERROR") ? "Intern fejl under behandling" : e) : "");
export const TRIGGER = { MANUAL: "Manuelt", SCHEDULE: "Planlagt", RETRY: "Genforsøg" };
export const LOG_KIND = { FETCH: "Hentning", DISCOVERY: "Fundet link", ROBOTS: "robots.txt" };
export const LOG_OUTCOME = {
  OK: "OK", ERROR: "Fejl", DISCOVERED: "Fundet", SKIPPED: "Sprunget over", NEEDS_OCR: "Kræver OCR/manuel", NO_PRICES: "Ingen priser",
  ROBOTS_OK: "robots.txt læst", NO_ROBOTS: "Ingen robots.txt",
};
export const VERIFICATION = {
  UNVERIFIED: "Ikke verificeret",
  CLINIC_CONFIRMED: "Bekræftet af klinik",
  ADMIN_VERIFIED: "Verificeret af VetPris",
  OUTDATED: "Forældet",
  REJECTED: "Afvist",
};
export const PRICE_SOURCE_TYPE = {
  MANUAL_ADMIN: "Manuelt (VetPris)", CLINIC_SUBMITTED: "Indsendt af klinik", CLINIC_WEBSITE: "Klinikkens hjemmeside",
  PRICE_LIST: "Prisliste", PHONE: "Telefon", EMAIL: "E-mail", FICTIONAL_TEST: "Fiktive testdata", AI_COLLECTED: "Automatisk indsamlet",
};
export const SOURCE_TYPE = {
  CLINIC_WEBSITE: "Hjemmeside", PRICE_LIST_PDF: "Prisliste (PDF)", CLINIC_SUBMISSION: "Indsendt af klinik",
  PHONE: "Telefon", EMAIL: "E-mail", OTHER: "Andet",
};
export const ACCESS_STATUS = {
  NOT_REVIEWED: "Ikke gennemgået", ACCESSIBLE: "Tilgængelig", LOGIN_REQUIRED: "Kræver login", BLOCKED: "Blokeret", UNAVAILABLE: "Utilgængelig",
};
export const PERMISSION_BASIS = {
  NONE: "Intet grundlag", CLINIC_CONSENT: "Klinikkens samtykke", WRITTEN_AGREEMENT: "Skriftlig aftale",
  OWN_SUBMISSION: "Klinikkens egen indsendelse", PUBLIC_DATA_ASSESSMENT: "Vurdering af offentlige data",
};
export const PERMISSION_STATUS = { PENDING_REVIEW: "Afventer gennemgang", APPROVED: "Godkendt", RESTRICTED: "Begrænset", REVOKED: "Tilbagekaldt", EXPIRED: "Udløbet" };
export const RIGHTS_STATUS = {
  UNKNOWN: "Ukendt", NO_RESERVATION: "Intet forbehold", RESERVED_TDM: "Forbehold mod tekst- og datamining",
  RESERVED_ROBOTS: "Forbehold i robots.txt", RESERVED_TERMS: "Forbehold i vilkår",
};
export const ROLES = { SUPER_ADMIN: "Superadministrator", CLINIC_ADMIN: "Klinikadministrator", CLINIC_EDITOR: "Redaktør", CLINIC_VIEWER: "Læseadgang" };
export const RISK_FLAGS = { MANY_REQUESTS_BY_USER: "Mange anmodninger fra samme bruger", COMPETING_CLAIMS: "Konkurrerende anmodninger", CLINIC_ALREADY_MANAGED: "Klinikken har allerede en verificeret administrator", EMAIL_DOMAIN_MISMATCH: "E-maildomæne matcher ikke hjemmesiden" };
export const VERIFY_METHOD = { EMAIL: "E-mail", DOCUMENT: "Dokument", ADMIN_REVIEW: "Administratorgennemgang", INVITATION: "Invitation" };
export const PERMS = {
  "profile:edit": "Redigere profil", "locations:edit": "Redigere lokationer", "prices:edit": "Redigere priser",
  "sources:edit": "Redigere kilder", "users:manage": "Administrere brugere",
};
export const STAFF_PERMS = ["profile:edit", "locations:edit", "prices:edit", "sources:edit"];
export const CLAIM_STATUS = { PENDING: "Afventer", EMAIL_VERIFIED: "E-mail bekræftet", UNDER_REVIEW: "Under gennemgang", APPROVED: "Godkendt", REJECTED: "Afvist", REVOKED: "Tilbagekaldt" };
export const CLINIC_STATUS = { DRAFT: "Kladde", PUBLISHED: "Publiceret", ARCHIVED: "Arkiveret" };
export const MESSAGE_STATUS = { NEW: "Ny", READ: "Læst", ARCHIVED: "Arkiveret" };
export const CHANGE_TYPE = { CREATED: "Oprettet", UPDATED: "Opdateret", VERIFICATION_CHANGED: "Verificering ændret", DELETED: "Slettet" };

export const opts = (map) => Object.entries(map).map(([value, label]) => ({ value, label }));

const nf = new Intl.NumberFormat("da-DK", { maximumFractionDigits: 2 });
export const formatDKK = (v) => (v == null || v === "" ? "–" : `${nf.format(Number(v))} kr.`);
export const priceText = (p) => {
  if (p.price_type === "FROM") return `fra ${formatDKK(p.amount)}`;
  if (p.price_type === "ESTIMATE" || p.price_type === "RANGE") return p.amount_max ? `${nf.format(Number(p.amount))}–${formatDKK(p.amount_max)}` : `ca. ${formatDKK(p.amount)}`;
  return formatDKK(p.amount);
};
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleString("da-DK", { dateStyle: "short", timeStyle: "short" }) : "–");

export const TRANSPARENCY = {
  ADMIN_VERIFIED: ["Verificeret af VetPris", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  CLINIC_CONFIRMED: ["Bekræftet af klinik", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  SOURCE_VERIFIED: ["Fra dokumenteret kilde", "bg-sky-50 text-sky-800 border-sky-200"],
  UNVERIFIED: ["Ikke verificeret", "bg-slate-50 text-slate-700 border-slate-200"],
  OUTDATED: ["Forældet pris", "bg-amber-50 text-amber-800 border-amber-200"],
};
export const kr = (v) => Number(v).toLocaleString("da-DK", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

